import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import {getNorthCitiesIds} from "@models/area";
import BookmarkButton from "@atoms/bookmark";
import Alert from "@atoms/alert";
import ConvertPixelToRem from "@helpers/convert.rem";
import ButtonTransparent from "@atoms/button.transparent";
import {handleTypeTitle, handleTitle, handlePropertyPrice} from "@organisms/property/helpers/property_helpers";
import {isEmpty, time_ago} from "@helpers/helpers";
import {inArray} from "@helpers/arrays";
import Icon from "@atoms/icon";
import PriceIcon from "@icons/price.svg";
import ShareIcon from "@icons/share.svg";
import CallToVisitIcon from '@icons/call-to-visit.svg';

function MainInfo({property, isBadeSaba, bookmarkedProperties, handleBookmark, setShare, setPerContact, quickContact}) {
    const [northCitiesIds, setNorthCitiesIds] = useState([]);

    const showRequestForm = (property.request_contact || (!isEmpty(property.isBadeSaba) && property.isBadeSaba));
    const pricing = handlePropertyPrice(property, false, northCitiesIds);

    useEffect(() => {
        if (!northCitiesIds.length) {
            getNorthCitiesIds().then(ids => {
                setNorthCitiesIds(ids);
            })
        }
    }, []);

    return (
        <div className="position-relative">

            {
                (!property.archived) ?
                    <LeftIcons className="p-0 d-none d-lg-block">
                        <ButtonTransparent className="js-track-share icon-btn" onClick={() => setShare(true)}>
                            <Icon width={20} height={20} className=""><ShareIcon/></Icon>
                        </ButtonTransparent>

                        {
                            (!isBadeSaba) ?
                                <BookmarkButton className={'mr-24 icon-btn ' + (inArray(property.id, bookmarkedProperties) ? 'active' : '')} onClick={() => handleBookmark(!inArray(property.id, bookmarkedProperties))} width={20} height={20}/>
                                : ''
                        }
                    </LeftIcons>
                    : ''
            }

            <Heading>
                <TypeTitle className="d-block">{handleTypeTitle(property.deal_type, property.type, property.villa_type)}</TypeTitle>
                <address>{handleTitle(property, true, null, null, true)}</address>
            </Heading>

            {
                (pricing.length) ?
                    pricing.map(({price, label, extraLabel}, key) =>
                        <Price className="d-flex align-items-center">
                            <span className="h2">{price.num + ' ' + price.unit + ' ' + label}</span>
                            {
                                !isEmpty(extraLabel) ?
                                    <span className="mr-16">{extraLabel}</span>
                                    : ''
                            }
                        </Price>
                    )

                    : ''
            }

            <div className="mt-40 mt-lg-48">

                <Time className="d-block">{time_ago(property.boosted_at, '6_month')}</Time>

                <Code className="d-none d-lg-block">کد آگهی: <span className="bg-info">{property.id}</span></Code>

                {
                    (!isEmpty(quickContact.phone) && !showRequestForm && !property.archived && property.stage !== 'assigned') ?
                        <PhoneNumberWrapper onClick={() => setPerContact({show: true, property_id: property.id, city_id: property.city_id,})}
                                            className="js-track-quick-contact text-secondary-dark d-flex align-items-center mt-8 mb-16 mb-lg-0">
                            <div className={"h3 phone-number "}>{quickContact.phone}</div>
                            <span className={"mr-8 h6-normal " + (quickContact.show ? 'd-none' : '')}>(نمایش کامل)</span>
                        </PhoneNumberWrapper>
                        : ''
                }

            </div>

            {
                ((!isEmpty(property.archived) && !property.archived) && (!isEmpty(property.negotiable) && property.negotiable)) ?
                    <AlertBox type="danger">
                        <Icon width={42} height={42}><PriceIcon/></Icon>
                        <span className="mr-24">به دلیل نوسانات بازار، ممکنه قیمت این آگهی تغییر کرده باشه. برای اطلاع از قیمت دقیق، با مشاور این آگهی تماس بگیرید.</span>
                    </AlertBox>
                    :
                    (
                        ((!isEmpty(property.archived) && !property.archived) && (!isEmpty(property.type) && property.type === 'villa')) ?
                            <AlertBox type="warning">
                                <Icon width={42} height={42}><CallToVisitIcon/></Icon>
                                <span className="mr-24">توصیه می‌کنیم پیش از بازدید، برای دریافت قیمت دقیق و عکس‌های بیشتر با مشاور این ویلا تماس بگیرید.</span>
                            </AlertBox>
                            : ''
                    )
            }
        </div>
    )
}

export default React.memo(MainInfo);

// styles

const PhoneNumberWrapper = styled(ButtonTransparent)`
	
	.phone-number {
		font-weight: 500 !important;
		line-height: 1.06 !important;
		border-bottom: solid 1px ${props => props.theme.secondaryDark};
		letter-spacing: 1px;
		position: relative;
		
		&.ltr {
		    direction: ltr;
		}
	}
`;

const TypeTitle = styled.span`
    font-size: ${props => props.theme.fontSizeBase};
    color: ${props => props.theme.gray400};
    
    @media (max-width: ${props => props.theme.screenSmMax}) {
        line-height: 1.5;    
    }
`;

const AlertBox = styled(Alert)`
    margin-top: 48px;
    @media (max-width: ${props => props.theme.screenSmMax}) {
        margin-top: 24px;    
    }
`;

const Heading = styled.h1`
    font-weight: 300;
    
    @media (max-width: ${props => props.theme.screenXsMax}) {
        font-size: ${ConvertPixelToRem(18)} !important;
        line-height: 2.22;
        
        address {
            line-height: 1.8;
        }
    }
`;

const Price = styled.div`
    @media (max-width: ${props => props.theme.screenXsMax}) {
        .h1 {
            font-size: ${ConvertPixelToRem(18)};
            line-height: 2.22;
        }
    }
`;

const LeftIcons = styled.div`
    position: absolute;
    left: 0;
    z-index: 8;
`;

const Code = styled.span`
      font-size: ${props => props.theme.fontSizeBase};
      font-weight: 500;
      line-height: 1.8;
	  margin-top: 8px;
	  
	  span {
            padding: 1px 6px;
            border-radius: 4px;
        }
`;

const Time = styled.span`
	font-size: ${props => props.theme.fontSizeBase};
	font-weight: 500;
	line-height: 1.8;
`;